// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --toastAnimationEasing: cubic-bezier(0, 0, 0.2, 1);
  --toastFadeDistance: 0.5rem;
  --toastFadeDuration: 200ms;
  --toastMoveDuration: 300ms;
  --toastMaxHeight: 10rem;
}

[ftr-toast].toast-in {
  animation: toast-fade 200ms cubic-bezier(0, 0, 0.2, 1) forwards;
}

@media (prefers-reduced-motion: reduce) {

[ftr-toast].toast-in {
    animation: none
}
  }

[ftr-toast].toast-out {
  animation:
    toast-fade 200ms cubic-bezier(0, 0, 0.2, 1) reverse forwards,
    toast-move 300ms 200ms cubic-bezier(0, 0, 0.2, 1) forwards;
}

@media (prefers-reduced-motion: reduce) {

[ftr-toast].toast-out {
    animation: none
}
  }

@keyframes toast-fade {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes toast-move {
  from {
    max-height: 10rem;
    margin-top: 0;
  }
  to {
    max-height: 0;
    margin-top: calc(-.5rem);
    margin-bottom: 0;
  }
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
